// extracted by mini-css-extract-plugin
export default {"nav_button":"home_nav_button__hQhOK","navigate":"home_navigate__id3JR","title":"home_title__2iqJZ"};